module.exports = __webpack_public_path__ + "static/pay-0d43ab32dec4893ae2139f6d9c4aa43b.gif";